$(function() {
  function initializeFeaturedCollectionsTab() {
    let swiper1 = new Swiper(".mySwiper-1", {
      slidesPerView: 4,
      spaceBetween: 70,
      freeMode: true,
      speed: 500,
      breakpoints: {
        280: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
         1024: {
          slidesPerView: 4,
          spaceBetween: 50,
        },
      },
      on: {
        "activeIndexChange": function(swiper) {
          
          let index = swiper.activeIndex;
  
          if(index == 0) {
            $(".mySwiper-1 .featured-prev-next-button--prev").attr("disabled", true);
            $(".mySwiper-1 .featured-prev-next-button--next").removeAttr("disabled");
          }
          else if(index < swiper1.slides.length - 4) {
            $(".mySwiper-1 .featured-prev-next-button--next").removeAttr("disabled");
            $(".mySwiper-1 .featured-prev-next-button--prev").removeAttr("disabled");
          }
          else {
            $(".mySwiper-1 .featured-prev-next-button--next").attr("disabled", true);
            $(".mySwiper-1 .featured-prev-next-button--prev").removeAttr("disabled");
          }
        }
      }
    });
  
    $(".mySwiper-1 .featured-prev-next-button--next").on('click', function() {
      swiper1.slideTo(6);
    });
  
    $(".mySwiper-1 .featured-prev-next-button--prev").on('click', function() {
      swiper1.slideTo(0);
    });
  
  
    var swiper2 = new Swiper(".mySwiper-2", {
         slidesPerView: 4,
        spaceBetween: 70,
        speed: 500,
        freeMode: true,
        breakpoints: {
          280: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
        },
        // navigation: {
        //   nextEl: ".mySwiper-1 .featured-prev-next-button--next",
        //   prevEl: ".mySwiper-1 .featured-prev-next-button--prev",
        // },
      on: {
        "activeIndexChange": function(swiper) {
          
          let index = swiper.activeIndex;
          console.log(index)
  
          if(index == 0) {
            $(".mySwiper-2 .featured-prev-next-button--prev").attr("disabled", true);
            $(".mySwiper-2 .featured-prev-next-button--next").removeAttr("disabled");
          }
          else if(index < swiper2.slides.length - 4) {
            $(".mySwiper-2 .featured-prev-next-button--next").removeAttr("disabled");
            $(".mySwiper-2 .featured-prev-next-button--prev").removeAttr("disabled");
          }
          else {
            $(".mySwiper-2 .featured-prev-next-button--next").attr("disabled", true);
            $(".mySwiper-2 .featured-prev-next-button--prev").removeAttr("disabled");
          }
        }
      }
    });
  
    $(".mySwiper-2 .featured-prev-next-button--next").on('click', function() {
      swiper2.slideTo(6);
    });
  
    $(".mySwiper-2 .featured-prev-next-button--prev").on('click', function() {
      swiper2.slideTo(0);
    });
  
    $(".collection-tab-1").on('click', function() {
      $(this).attr("aria-current", true);
      $(".featured-collections-carousel__item-1").addClass("is-selected");
      $(".featured-collections-carousel__item-1").css("opacity", 1);
      $(".featured-collections-carousel__item-1").css("transform", "translateY(0px)");
      $(".collection-tab-2").attr("aria-current", false);
      $(".featured-collections-carousel__item-2").removeClass("is-selected");
      $(".featured-collections-carousel__item-2").css("opacity", 0);
      $(".featured-collections-carousel__item-2").css("transform", "translateY(15px)");
    });
  
    $(".collection-tab-2").on('click', function() {
      $(this).attr("aria-current", true);
      $(".featured-collections-carousel__item-2").addClass("is-selected");
      $(".featured-collections-carousel__item-2").css("opacity", 1);
      $(".featured-collections-carousel__item-2").css("transform", "translateY(0px)");
      $(".collection-tab-1").attr("aria-current", false);
      $(".featured-collections-carousel__item-1").removeClass("is-selected");
      $(".featured-collections-carousel__item-1").css("opacity", 0);
      $(".featured-collections-carousel__item-1").css("transform", "translateY(15px)");
    });
  }

  initializeFeaturedCollectionsTab();
  

  if(Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initializeFeaturedCollectionsTab());
    document.addEventListener('shopify:section:reorder', () => initializeFeaturedCollectionsTab());
  }

  

  $('.featured-collections-product-card__quick-add-button').on('click', function(e) {
    e.preventDefault();
    // $(this).parent().submit()
    let form_data = $(this).closest('form').serialize();
    var properties_param = ''
    if (typeof properties !== 'undefined') {
      properties_param = '&' + properties
    }
    var qty = 1;
    var q = parseInt($('.g-stickybar[selected] .quantity input').val());
    var q_ = parseInt($(self).closest('form').find('[name="quantity"]').val());
    if (typeof q !== 'undefined' && q > 1) qty = q;
    if (typeof q_ !== 'undefined' && q_ > 1) qty = q_;

    $.ajax('/cart/add.js', {
      data: form_data + '&quantity=' + qty + properties_param,
      type: "POST",
      complete: function (result) {
        console.log(result);
        var add_status = result.status
        var add_response = JSON.parse(result.responseText);
        
        $.ajax({
          url: '/cart.json',
          type: 'GET',
          complete: function (res) {
            cart = JSON.parse(res.responseText);
            if(add_status === 200) {
              $("#cart-notification").addClass("active");
              $(".cart-notification-product").remove();
              let itemHTML = "";
              let items = cart.items;                       
              let optionHTML = "";
              add_response.options_with_values.forEach(function(option) {
                optionHTML += `
                  <div class="product-option">
                    <dt>${ option.name }</dt>
                    <dd>${ option.value }</dd>
                  </div>
                `
              });
  
              itemHTML += `
                <div class="cart-notification-product">
                  <div class="cart-notification-product__image global-media-settings">
                    <img src="${ add_response.featured_image.url }" alt="${ add_response.alt }" width="70" height="70" loading="lazy" />
                  </div>
                  <div>
                    <p class="caption-with-letter-spacing light">${ add_response.vendor }</p>
                    <h3 class="cart-notification-product__name h4">${ add_response.product_title }</h3>
                    <dl>${ optionHTML }</dl>
                  </div>
                </div>
              `              
  
              $('.cart-notification__header').after(itemHTML);
              $('.cart-count-bubble span').text(cart.item_count);
              $('#cart-notification-button').text(`View cart (${ cart.item_count })`);
            }
            
          }
        });
      }
    });
    console.log(form_data);
  })
})

